// src/icons/EyeDropper.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function EyeDropper() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.1468 5.84804L13.8883 5.58948L15.21 4.26777C16.1863 3.29146 16.1863 1.70854 15.21 0.732233C14.2337 -0.244078 12.6508 -0.244078 11.6744 0.732233L10.3527 2.05394L10.0942 1.79538C9.50839 1.2096 8.55865 1.2096 7.97286 1.79538C7.38707 2.38117 7.38707 3.33092 7.97286 3.9167L8.26066 4.2045L2.12438 10.3408C2.02485 10.4403 1.9377 10.5515 1.8648 10.6719L0.326364 13.2129C-0.621051 14.7778 1.16487 16.5637 2.72972 15.6163L5.27078 14.0779C5.39118 14.005 5.50235 13.9178 5.60187 13.8183L11.7382 7.682L12.0255 7.96936C12.6113 8.55515 13.561 8.55515 14.1468 7.96936C14.7326 7.38357 14.7326 6.43383 14.1468 5.84804ZM9.32132 5.26516L10.6775 6.62134L4.54121 12.7576C4.527 12.7718 4.51112 12.7843 4.49391 12.7947L1.95286 14.3331C1.88025 14.3771 1.82762 14.3793 1.78992 14.3734C1.7446 14.3663 1.69213 14.3416 1.6466 14.2961C1.60107 14.2505 1.5764 14.198 1.56927 14.1527C1.56334 14.115 1.56556 14.0624 1.60952 13.9898L3.14796 11.4487C3.15837 11.4315 3.17082 11.4157 3.18504 11.4014L9.32132 5.26516Z",
          fill: "currentColor"
        }
      )
    }
  );
}

export {
  EyeDropper
};
